// Note: Disabling this rule as React's useEffect hook is conflicting with
// ESLint's expected no-use-before-define behavior (which works just fine)
/* eslint-disable no-use-before-define */

import React, { useEffect, useState } from 'react';
import { Redirect, useParams } from 'react-router-dom';
//
import Layout from 'components/layout';
import { IDeal, IDealState } from 'store/deals/types';
import labels from 'constants/labels';
import DealResults from 'components/deal-results';
import routes from 'router/routes';

// Takes an array of products and returns true if all contain
// the necessary price and batna fields
function shouldEvaluate(deal?: IDeal): boolean {
  if (!deal?.products?.length) {
    return false;
  }
  return deal?.products.every(p => p.basePrice?.formula && p.mainBatna?.formula);
}

interface IDealDetailPage {
  editDealStart: Function;
  deals: IDealState;
  getDealEvaluation: Function;
  setPageTitle: Function;
  getDeals: Function;
}

const DealDetailPage = ({ editDealStart, deals, getDealEvaluation, setPageTitle, getDeals }: IDealDetailPage) => {
  const [isInitialized, setIsInitialized] = useState(false);
  // Find deal in local store
  // @ts-ignore
  const { id } = useParams();
  const deal = deals.data.find((d: IDeal) => d.id === id);

  useEffect(() => {
    // Handle no id scenario
    if (!id) {
      return;
    }

    // Deep linking
    // deals don't exist, but id does
    if (!deal) {
      getDeals();
    }

    // Initialize page
    if (!isInitialized) {
      setIsInitialized(true);
      editDealStart(deal);
      setPageTitle(labels.titles.pages.dealDetail);

      // Only evaluate if products are present and complete
      if (shouldEvaluate(deal)) {
        getDealEvaluation();
      }
    }
  }, [deal, editDealStart, getDealEvaluation, isInitialized, setPageTitle, getDeals, id]);

  if (!deal) {
    return <Redirect to={routes.dashboard} />;
  }

  return (
    <Layout>
      <DealResults />
    </Layout>
  );
};

export default DealDetailPage;
